import constant from "../constant";
import {Classes} from "@blueprintjs/core";
import classes from 'classnames';

const initState = {
  filesExpand: true,
  files: [
    {
      id: -1,
      icon: 'folder-close',
      label: 'src',
      className: classes(Classes.TEXT_SMALL ,'folder'),
      isExpanded: true,
      childNodes: [
        {
          id: 0,
          icon: "document",
          label: "main.py",
          className: classes(Classes.TEXT_SMALL, 'file'),
          isSelected: true
        },
        {
          id: 1,
          icon: "document",
          label: "secondary.py",
          className: classes(Classes.TEXT_SMALL, 'file'),
        }
      ]
    },
  ]
};

export default (state = initState, action) => {
  switch (action.type) {
    case constant.playground.TOGGLE_FILES:
      return {
        ...state,
        filesExpand: !state.filesExpand
      };
    case constant.playground.UPDATE_FILES:
      return {
        ...state,
        files: action.payload
      };
    default:
      return state;
  }
}
